
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Layout from "./components/Layout";
import Footnote from "./components/Footnote";
import Progress from "./components/Progress";
import SlideTitle from "./components/SlideTitle";
import Icon from "./components/Icon";
import Font from "./components/Font";
import {
 BLUE,
  RED,
  YELLOW,
  GREEN,
  PINK,
  DARK_BLUE,
  DARK_RED,
  DARK_YELLOW,
  DARK_GREEN,
  DARK_PINK,
  LIGHT_GREY,
  DARK_GREY,
  GREY,
  BLACK,
  WHITE
} from "./components/Colours.js";
import BG1 from "./images/bg1.jpg";
import BG2 from "./images/bg2.jpg";
import Brett from "./images/brett.jpg";
import SlideJourney from "./images/slide-journey.svg";
import SlideAreas from "./images/slide-areas.svg";
import SlideMarket from "./images/slide-market.svg";
import SlideComponents from "./images/slide-components.svg";
import CAT from "./images/climate-action-tech.png";
import Lighthouse from "./images/lighthouse.png";
import W3C from "./images/w3c.png";
import WebsiteCarbon from "./images/websitecarbon.png";
import ElectricityMaps from "./images/electricity-maps.png";
import QrCode from "./images/qrcode.png";
export { default as theme } from "./components/Theme";
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Footer = makeShortcode("Footer");
const Image = makeShortcode("Image");
const Notes = makeShortcode("Notes");
const Split = makeShortcode("Split");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <Footer mdxType="Footer">
      <Progress mdxType="Progress" />
    </Footer>
    <Layout color={DARK_GREY} mdxType="Layout">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Key`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Left Arrow, Page Up, Shift + Space`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Go to previous slide`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Right Arrow, Page Down, Space`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Go to next slide`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Option + P`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Toggle Presenter Mode`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Option + O`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Toggle Overview Mode`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Option + G`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Toggle Grid Mode`}</td>
          </tr>
        </tbody>
      </table>
      <div style={{
        display: "flex",
        marginTop: "50px",
        padding: "50px"
      }}>
        <p><a parentName="p" {...{
            "href": "https://github.com/tackaberry/cncf-cloud-sustainability"
          }}>{`This presentation on github`}</a></p>
        <Image src={QrCode} style={{
          marginLeft: "50px",
          height: "200px",
          width: "200px"
        }} mdxType="Image" />  
      </div>
    </Layout>
    <hr></hr>
    <Layout color={DARK_GREY} mdxType="Layout">
      <h1>{`Cloud Sustainability: A Practical Guide for Building a More Sustainable Internet`}</h1>
      <h3>{`For CNCF Ottawa`}</h3>
      <h3>{`November 28, 2023`}</h3>
      <h2>{`Brett Tackaberry, Principal Architect, Google Cloud Canada`}</h2>
    </Layout>
    <hr></hr>
    <Layout color={DARK_GREEN} mdxType="Layout">
      <h1>{`Cloud Sustainability`}</h1>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`All jobs are climate jobs. We're going to start there. `}</p>
      <p>{`I want to help you understand how your work as engineers can have a positive impact on the environment. `}</p>
      <p>{`Im going to start off with a little bit of my journey, the context, and then we’ll get into the top ten things you can do make your cloud more sustainable.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <Split mdxType="Split">
        <Image src={Brett} style={{
          height: "600px",
          width: "600px"
        }} mdxType="Image" />
        <h1>{`About me`}</h1>
        <p>{`help people do awesome things with technology`}</p>
        <p>{`help companies grow, help teams do better`}</p>
        <p>{`use technology make the world a better place`}</p>
      </Split>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`I'm Brett Tackaberry. `}</p>
      <p>{`I’m a principal architect at Google Cloud Canada.  I help people do awesome things with technology.   And right now, Im helping govt and the public sector do more in the cloud. `}</p>
      <p>{`Over my career I've spent lot of time building community helping to bring technology to the social sector.  I ran hackathons, ran tech4good, contributed to civic tech. This was and is important to me. `}</p>
    </Notes>
    <hr></hr>
    <Layout image={SlideJourney} color={WHITE} mdxType="Layout">
      <SlideTitle mdxType="SlideTitle">My Journey</SlideTitle>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`More recently I have been spending my time finding ways to put my effort in to helping the climate crisis. `}</p>
      <p>{`When I was working at a company in town called Rebel, I started to introduce sustainability and green concepts into our offering. If you're not familiar we were a web hosting company, amongst other things. `}</p>
      <p>{`We made a few decisions that would result in less carbon footprint. `}</p>
      <p>{`For example, when AWS launched in Montreal, we launched new locations and set the default to Canada. `}</p>
      <p>{`Montreal data centres are powered with green energy - so, this had an impact. `}</p>
      <p>{`This kicked off more green initiatives with the team.`}</p>
      <p>{`For me, it inspired me to really evaluate how I can use my experience to work on climate.  `}</p>
      <p>{`I dove right in, learned a tonne, I moved to work with a company building enivronment and civic focused apps, and yes, now at google. But along the way contributing more to how we can build to a more sustainable internet.  `}</p>
      <p>{`I'm not an expert, but I'm going to share what I've learned so far.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={BLACK} image={BG2} mdxType="Layout">
      <h1>{`Context`}</h1>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`First, our shared context. Our changing climate. `}</p>
    </Notes>
    <hr></hr>
    <Layout color={GREEN} mdxType="Layout">
      <h1>{`The Climate Context`}</h1>
      <h2><Icon name="looks_one" mdxType="Icon" />{` 1.5 ºC`}</h2>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The Paris agreement gave us the threshold to restrict global warming to no more than 1.5 degrees Celsius to mitigate the worst impacts of climate change`}</p>
      <p>{`So, we have to act now`}</p>
    </Notes>
    <hr></hr>
    <Layout color={RED} mdxType="Layout">
      <h1>{`The Climate Context`}</h1>
      <h2><Icon name="looks_two" mdxType="Icon" />{` Carbon Footprint of ICT is Subtantial`}</h2>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The digital industry is responsible for between 2 and 5 % of global emissions. `}</p>
      <p>{`If the internet were a country it would be one of the top 5 polluters.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_YELLOW} mdxType="Layout">
      <h1>{`The Climate Context`}</h1>
      <h2><Icon name="looks_3" mdxType="Icon" />{`Our Industry is Growing`}</h2>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Since 2010, the number of internet users has more than doubled. Global traffic has increased by 25 times. `}</p>
      <p>{`And what’s more, page size more than doubled in some cases. `}</p>
      <p>{`And with massive growth in AI, IoT,  we'll see it grow to well over 10% within the next 10 years. `}</p>
    </Notes>
    <hr></hr>
    <Layout color={BLACK} image={BG1} mdxType="Layout">
      <h1>{`Our Challenge`}</h1>
      <p>{`Our challenge is to divorce the growth of the usage of IT from its impact on the environment.`}</p>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Our challenge is to divorce the growth of the usage of IT from its impact on the environment.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`Architecture decisions we make`}</h1>
      <h1>{`have an `}<Font color={YELLOW} mdxType="Font">{`impact`}</Font></h1>
      <h1>{`on our environment`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`There are things that`}</h1>
      <h1><Font color={YELLOW} mdxType="Font">{`software engineers`}</Font></h1>
      <h1>{`can do to help`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`There are things that`}</h1>
      <h1><Font color={YELLOW} mdxType="Font">{`designers`}</Font></h1>
      <h1>{`can do to help`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`There are things that`}</h1>
      <h1><Font color={YELLOW} mdxType="Font">{`product owners`}</Font></h1>
      <h1>{`can do to help`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`There are things that`}</h1>
      <h1><Font color={YELLOW} mdxType="Font">{`you`}</Font></h1>
      <h1>{`can do to help`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`Green Software principles`}</h1>
      <ul>
        <li parentName="ul"><em parentName="li">{`Energy Efficiency`}</em>{`: Consume the least amount of electricity possible`}</li>
        <li parentName="ul"><em parentName="li">{`Hardware Efficiency`}</em>{`: Use the least amount of embodied carbon possible`}</li>
        <li parentName="ul"><em parentName="li">{`Carbon Awareness`}</em>{`: Do more when the electricity is clean and less when it’s dirty`}</li>
      </ul>
      <p>{`Read more at `}<a parentName="p" {...{
          "href": "https://greensoftware.foundation/"
        }}>{`Green Software Foundation`}</a></p>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`It starts with principles we have to adopt. Principles turn into patterns and patterns turn into practices. Practices without principles lose their meaning and value over time- practices with principles will get better with continuous improvement.`}</p>
      <ul>
        <li parentName="ul"><em parentName="li">{`Energy Efficiency`}</em>{`: Consume the least amount of electricity possible`}</li>
        <li parentName="ul"><em parentName="li">{`Hardware Efficiency`}</em>{`: Use the least amount of embodied carbon possible`}</li>
        <li parentName="ul"><em parentName="li">{`Carbon Awareness`}</em>{`: Do more when the electricity is clean and less when it’s dirty`}</li>
      </ul>
    </Notes>
    <hr></hr>
    <Layout color={DARK_GREEN} mdxType="Layout">
      <h1>{`Top 10 things you can do to make the internet more sustainable`}</h1>
    </Layout>
    <hr></hr>
    <Layout color={DARK_RED} mdxType="Layout">
      <h1>{`1. Measure and experiment`}</h1>
      <ul>
        <li parentName="ul">{`Measure consumption of your software`}</li>
        <li parentName="ul">{`Carbon sense - GCP's carbon footprint tool`}</li>
        <li parentName="ul">{`Cloud Carbon Footprint - Open source tool to measure carbon footprint of your cloud infrastructure`}</li>
        <li parentName="ul">{`Expand FinOps to include GreenOps`}</li>
        <li parentName="ul">{`Lighthouse - Google Chrome Dev Tools`}</li>
        <li parentName="ul">{`Website Carbon - Measure the carbon footprint of your website`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`If you're just getting started, your first step will be an assessment. You can't improve what you don't measure.   There are a number of tools that can help you understand the carbon impact of your software.  `}</p>
      <p>{`You might first start to look at CPU, memory, storage usage. Then you will want to take a step further to understand power consumption.`}</p>
      <p>{`Your cloud providers will have the rudiments of usage reporting and you will have already integrated this into your FinOps dashboard. You can take this a step further and integrate carbon reporting into your FinOps dashboard.  This is called GreenOps.  `}</p>
      <p>{`GCP has a simple tool called Carbon Sense that will give you a rough estimate of the carbon footprint of your GCP projects.  Other cloud providers have similar tools.  These are a great place to start.  You would have to do a little work to operationalize sustainability concepts in the cloud. `}</p>
      <p>{`Cloud Carbon Footprint is an open source tool that will give you a more detailed view of your cloud infrastructure.   It takes a bit of work to get it set up, but it's worth it. It works from Cost and Usage Reports (CUR) that are downloaded and transformed or you can integrate directly.  It will give you a detailed view of your cloud infrastructure and the carbon footprint of each component.  It will also give you a view of the carbon footprint of your cloud infrastructure over time.  This is a great tool to help you understand the impact of your cloud infrastructure and to help you make decisions about how to optimize it.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_RED} mdxType="Layout">
      <h1>{`Measuring Cluster Efficiency`}</h1>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`eBPF, Cilium - used with K8s - brings control and observability enhancing security, performance, and networking`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li"><a parentName="p" {...{
              "href": "https://sustainable-computing.io/"
            }}>{`KEPLER`}</a>{` - Kubernetes Energy Performance Label for Efficiency in Research - a tool to measure and optimize energy efficiency of Kubernetes clusters`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`KubeGreen - Reduce CO2 footprint of your clusters`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Cloud Native Computing Foundation sandbox project`}</p>
        </li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`KEPLER - using CPU performance counters and machine learning (ML) models to estimate power consumption of workloads running on Kubernetes clusters.`}</p>
      <p>{`Kepler leverages eBPF programs to probe per-container energy consumption related to system counters and exports them as metrics. `}</p>
      <p>{`KubeGreen - An operator to reduce CO2 footprint of your clusters by suspending idle pods, scaling down when possible`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`2. Use the cloud`}</h1>
      <h2>{`Carbon intensity (ton CO2-eq/workload) of cloud is 3x lower than on-prem`}</h2>
      <Footnote mdxType="Footnote">
        <p><a parentName="p" {...{
            "href": "https://vtechworks.lib.vt.edu/bitstream/handle/10919/109747/Siddik_2021_Environ._Res._Lett._16_064017.pdf"
          }}>{`Siddik, Shabi, Marston “The environmental footprint of data centers in the United States” (2021)`}</a></p>
      </Footnote>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The carbon intensity of the cloud is much lower because the computing workloads is much higher density per energy use.  Hyperscalers are obviously highly incented to run more efficiently.   Water intensity is also more than 5x lower.  `}</p>
    </Notes>
    <hr></hr>
    <Layout mdxType="Layout">
      <h1>{`3. Spatial and temporal optimization for low-carbon`}</h1>
      <Image src={ElectricityMaps} style={{
        height: "600px",
        width: "1200px"
      }} mdxType="Image" />
      <Footnote mdxType="Footnote">
        <p><a parentName="p" {...{
            "href": "https://app.electricitymaps.com/map"
          }}>{`https://app.electricitymaps.com/map`}</a></p>
      </Footnote>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Carbon awareness is important. Low-carbon energy means energy that is derived using little to no carbon.`}</p>
      <p>{`Low-carbon energy includes: clean (no emissions like nuclear), green (natural sources like hydro), renewable (solar, wind)`}</p>
      <p>{`This screenshot is from ElectricutyMaps.com.  It shows the carbon intensity of electricity in real time.  `}</p>
      <p>{`Understanding carbon intensity of power means you can reduce carbon footprint by running workloads in regions with low carbon intensity.  This is called spatial optimization.  It also means you can reduce carbon footprint by running workloads when the carbon intensity is low.  This is called temporal optimization.`}</p>
      <p>{`there's a popular article from a few years ago, outlining how Google shifts compute workloads to follow the sun and follow the wind. This is a great example of temporal optimization.  But it's not just Google.  We all have the ability to do this.  We can schedule workloads to run when the electricity is cleanest. `}</p>
      <p><a parentName="p" {...{
          "href": "https://blog.google/inside-google/infrastructure/data-centers-work-harder-sun-shines-wind-blows/"
        }}>{`https://blog.google/inside-google/infrastructure/data-centers-work-harder-sun-shines-wind-blows/`}</a></p>
      <p>{`Consider, too, a multi-cloud scenario, consider carbon-aware workloads. If services were able to choose the right region, at the right time of the day, based on the carbon intensity of the electricity, we could reduce the carbon footprint of a cluster consdiderably `}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_YELLOW} mdxType="Layout">
      <h1>{`4. Optimize for energy efficiency (and carbon efficiency)`}</h1>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`the more you use a computer, the more efficient it becomes`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`an idle server has a carbon cost from both embedded carbon as well as inefficient utilization`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Rightsizing, Autoscaling, and Autoscaling to zero, Serverless`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Turn off what you don’t need, schedule workloads to run when power is cleanest`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Use the most efficient hardware possible - ARM vs x86, GPUs, TPUs, ASICs, FPGAs - also upgrade to latest version`}</p>
        </li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The more you use a computer, the more efficient it becomes. Not only does it become more efficient, but it also becomes more carbon efficient.  This is because the embodied carbon of the hardware is amortized over the lifetime of the hardware.  An idle server has a carbon cost from both embedded carbon as well as inefficient utilization.  This is why it's important to rightsize your workloads, autoscale, and autoscale to zero - serverless is very efficient.  `}</p>
      <p>{`Turn off what you don't need - dev tooling, staging sites can be turned off in teh evenening and on the weekends.  `}</p>
      <p>{`Per the last slide - you can Also schedule workloads to run when power is cleanest.`}</p>
      <p>{`Lastly, using the right chip architecture is better for energy efficiency. First, upgrade to the latest verison as your cloud provider makes it available. Choose the right chip for the job, and don't overprovision. ASICs, FPGAs are more efficient because they're application specific. GPUs, TPUs are more efficient for ML workloads.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_PINK} mdxType="Layout">
      <h1>{`5. Async and batch processing`}</h1>
      <ul>
        <li parentName="ul">{`Batch processing is more efficient than real-time processing`}</li>
        <li parentName="ul">{`Event driven is more efficient than polling`}</li>
        <li parentName="ul">{`Applies to front end and back end`}</li>
        <li parentName="ul">{`Micro-services, automation and resilience`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Bundling many processes will be more efficient than running many processes one at a time`}</p>
      <p>{`Consider this on the the client side as well - bundling requests to the server, or using websockets instead of polling - think of web front end polling a web api efery 10s vs using websockets and having updates pushed to the client.`}</p>
      <p>{`I dont have to tell this crowd that event driven is more effective and just better, but it’s worth mentioning that it’s also more efficient.  Software polling is inefficient and wasteful.`}</p>
      <p>{`As services are able to scale and fail independently, better resilience leads to more efficient use of resources. There's no thrashing around.  This leads to less failures or outages. I might come back to this a few times but Failures result in a lot of wasted time and effort to fix and remediate.  The more resilient your system, the less time you spend fixing it, and the more time you spend building new features. `}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_RED} mdxType="Layout">  
      <h1>{`6. Security`}</h1>
      <ul>
        <li parentName="ul">{`Build security into your applications and services`}</li>
        <li parentName="ul">{`Keep malicious traffic off your network`}</li>
        <li parentName="ul">{`Keep software and dependencies up to date`}</li>
        <li parentName="ul">{`Implement secure, ethical and sustainable data practices`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`We're all aware of the amount of malicious traffic on the internet.  This traffic is not only a security risk, but it's also a waste of energy.  It's a waste of energy to process the traffic, to store logs of it, and it's a waste of energy to send it.  It's also a waste of energy as the user processes it, or endpoint security does what it has to.  The more we can do to prevent malicious traffic from reaching our services, the more efficient our systems will be.  By efficient I mean efficient in delivering value, scaling up to handle worthless traffic is wasteful. The part we already know is it has an impact on our users - from integrity of their data to availability of the services they rely on. `}</p>
      <p>{`Secondly, keeping software and dependencies up to date is a security best practice, but it's also a sustainability best practice.  The more up to date your software is, the more efficient it is.  Software is always getting more efficient.  `}</p>
      <p>{`And again, secure breaches and any sort of remediation takes time and resources away from being productive and building new features.  People are a carbon sink. The more time we spend building new features, the more "carbon efficient" as a system we are. `}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`7. Data practices`}</h1>
      <ul>
        <li parentName="ul">{`Store data according to user needs`}</li>
        <li parentName="ul">{`Reduce data duplication and redundancy`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Failing to deliver on data privacy and security is a huge risk to your business and to your users.  It's also a huge waste of energy.  `}</p>
      <p>{`The more data you collect, the more energy it takes to store it, process it, and transmit it.  `}</p>
      <p>{`It starts with respecting the user, their data, and their privacy - dont collect data you dont need, and dont keep it longer than you need it.  Adhere to laws and regulations. Then be transparent about what you do with it, provide the user with control over the data you collect.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_GREEN} mdxType="Layout">
      <h1>{`8. Use Open Source Software`}</h1>
      <ul>
        <li parentName="ul">{`Open source software is more secure, more reliable, and more sustainable`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Open source software tends to remain in service much longer than proprietary software.  This is because it's more secure, more reliable, and more sustainable. And its more secure and more efficient because its open to scrutiny and review.`}</p>
      <p>{`If software is in service longer, then hardware can stay in service longer.  Closed software tends to be more tightly coupled to hardware, and is more likely to be retired when hardware is retired - or causing hardware to be retired earlier.  There are many common situations where the embodied carbon outweighs the carbon cost of utilization of a device. Theres lots of complaints how your iphone gets slower and slower with each update.`}</p>
      <p>{`Open-source however can also be refactored to be streamlined for precision tasks. Proprietrary software tends to be more bloated to accommodate a wider range of use cases.  You see examples of lightweight images, or lightweight distributions or custom distributions - and these custom distributions are tailored perhaps to hardware or moreover for performance. `}</p>
      <p>{`Keep fighting for open source.`}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_YELLOW} mdxType="Layout">
      <h1>{`9. Optimize CI/CD`}</h1>
      <ul>
        <li parentName="ul">{`Automation and standardization remove waste and error`}</li>
        <li parentName="ul">{`Avoid overprovisioning and underutilization`}</li>
        <li parentName="ul">{`Tight feedback loops identify areas of improvement`}</li>
        <li parentName="ul">{`Cache, cache, cache`}</li>
        <li parentName="ul">{`Update dependencies regularly`}</li>
        <li parentName="ul">{`Lightweight image, multi-stage builds`}</li>
        <li parentName="ul">{`What kinds of testing and when `}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Automation and standardization remove waste and error.  You want to avoid overprovisioning and underutilization - even in CICS pipeline tooling.  Tight feedback loops identify areas of improvement. On front end CICD, for example, you can integrate lighthouse performance check on build or pre-commit, and if you give it a budget or limit, then you can fail the commit causing the developer to go back and fix the sustainability problem. `}</p>
      <p>{`Cache, cache, cache. Its easy to overlook inefficient caching in the build process, but caching save a lot of compute and data transfer. `}</p>
      <p>{`Multi-stage builds help you create lightweight images.  `}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_PINK} mdxType="Layout">
      <h1>{`10. Frameworks are your friends`}</h1>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`Number 10, saving the best for last.  Use the sustainability guides and frameworks.  I have links for all these in the resources section on the repo. `}</p>
    </Notes>
    <hr></hr>
    <Layout mdxType="Layout">
      <h1>{`W3C Web Sustainability Guidelines`}</h1>
      <ul>
        <li parentName="ul">{`Launched Draft 1.0 in September 2023`}</li>
        <li parentName="ul">{`Covering Design, Development, Infrastructure, and Business Strategy`}</li>
        <li parentName="ul">{`94 Guidelines, 232 Success Criteria`}</li>
        <li parentName="ul">{`From the people that brought you WCAG`}</li>
        <li parentName="ul">{`Join me Nov 15 at Ottawa JS Meetup`}</li>
      </ul>
    </Layout>
    <Notes mdxType="Notes">
      <p>{`The W3C Web Sustainability Guidelines launched recently.  These are a holistic set of guidelines that cover full life cycle of buidling and operating a digital product form the Business Strategy, UX design, software to infrastructure.  They are from the people that brought you WCAG.  I'll be talking about these in more detail at the Ottawa JS meetup on Nov 15. `}</p>
    </Notes>
    <hr></hr>
    <Layout color={DARK_BLUE} mdxType="Layout">
      <h1>{`Read more and Get Involved`}</h1>
      <ul>
        <li parentName="ul">{`CNCF - Cloud Native Sustainability Week and `}<a parentName="li" {...{
            "href": "https://cloud-native.slack.com/archives/C03F270PDU6"
          }}>{`#tag-environmental-sustainability`}</a></li>
        <li parentName="ul">{`ClimateAction.tech - A community of practice of tech workers that provides support and guidance for systemic change in our organisations and industries, to face the climate crisis.`}</li>
        <li parentName="ul">{`Check out the resources on the `}<a parentName="li" {...{
            "href": "https://github.com/tackaberry/cncf-cloud-sustainability"
          }}>{`repo`}</a></li>
      </ul>
    </Layout>
    <hr></hr>
    <Layout color="BLACK" mdxType="Layout">
      <Split mdxType="Split">
        <Image src={QrCode} style={{
          height: "400px",
          width: "400px"
        }} mdxType="Image" /> 
        <h1>{`Thank you 🙏`}</h1>
        <ul>
          <li parentName="ul">
            <p parentName="li"><a parentName="p" {...{
                "href": "https://www.linkedin.com/in/tackaberry/"
              }}>{`https://www.linkedin.com/in/tackaberry/`}</a></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><a parentName="p" {...{
                "href": "https://github.com/tackaberry"
              }}>{`https://github.com/tackaberry`}</a></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><a parentName="p" {...{
                "href": "https://cncf-cloud-sustainability.tackaberry.dev/"
              }}>{`This Presentation`}</a></p>
          </li>
        </ul>
      </Split>
    </Layout>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;